// Run this Angular example by adding the following HTML markup to your view:
//
// <films-filter>Loading...</films-filter>
//
// <%= javascript_pack_tag 'films_filter' %>

import { enableProdMode } from '@angular/core'

require('../films_filter');

if (process.env.ENV === 'production') {
  enableProdMode();
}